import { Route } from '@angular/router'
import { TransparencyRegisterComponent } from './transparency-register.component'

export const transparencyRegisterRoutes: Route[] = [
  {
    path: 'transparency-reports/register',
    component: TransparencyRegisterComponent
  }
]
